import React, {useEffect, useState} from 'react';
import {useShipmentApi} from "../../../../../app/api/shipment";
import {BLErrorCode} from "../../../../../app/enums/BLErrorCode";
import FormLoadingScreen from "../../../../../components/ui/loaders/FormLoadingScreen/FormLoadingScreen";
import Alert from "../../../../../components/ui/Alert/Alert";
import {isAxiosError} from "axios";
import {ResponseResultCode} from "../../../../../app/enums/ResponseResultCode";
import {IError} from "../../../../../app/interfaces/response/IResponse";
import {useTranslation} from "react-i18next";
import {ApplicationHubMessageAction} from "../../../../../app/signalR/applicationHub/IApplicationHubMessage";

type CopyOrProps = {
    id: string;
    close?: () => void;
}

const alertStyle = {
    minHeight: '40px',
    fontSize: '12px',
    fontWeight: 'bold'
} as React.CSSProperties;

const CopyOr: React.FC<CopyOrProps> = ({
                                           id,
                                           close
                                       }) => {
    const {t} = useTranslation();
    const [errors, setErrors] = useState<Array<BLErrorCode>>([]);

    const {
        getCopyOrData: {
            isLoading,
            cancel,
            query: getCopyOrData
        }
    } = useShipmentApi();

    useEffect(() => {
        if (!id || id === '') {
            return;
        }


        (async () => {
            try {
                const response = await getCopyOrData(id);
                if (response?.status === 200 && response.data && response.data.data && response.data.data) {
                    if (close) {
                        close();
                    }

                    window.open(response.data.data, '_blank');
                }
            } catch (err) {
                if (isAxiosError(err)) {
                    if (err.response && err.response.data && err.response.status === 422 &&
                        err.response.data.resultCode === ResponseResultCode.NotValidData &&
                        err.response.data.errors && Array.isArray(err.response.data.errors)) {
                        err.response.data.errors.forEach((e: IError) => {
                            setErrors(prev => {
                                if (!prev.find(pr => pr === e.errorCode)) {
                                    return [
                                        ...prev,
                                        e.errorCode
                                    ];
                                }

                                return prev;
                            });
                        });
                    } else if (close) {
                        close();
                    }
                }
            }
        })();

        return () => {
            cancel();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (isLoading || errors.length <= 0) {
        return (
            <FormLoadingScreen height={`200px`} style={{padding: '5px'}}/>
        )
    }

    return (
        <div className={'h100 w100'}>
            {errors.map((err, index) => {
                switch (err) {
                    case BLErrorCode.ClientIsTRANSPOREON:
                        return (
                            <Alert type={'Error'}
                                   id={`copy-or-client-is-transporeon-error-${index}`}
                                   key={err}
                                   style={alertStyle}>
                                {t("shipment.warnings.copy-or-client-is-transporeon")}
                            </Alert>
                        );
                    case BLErrorCode.ClientIsIOR:
                        return (
                            <Alert type={'Error'}
                                   id={`copy-or-client-is-ior-error-${index}`}
                                   key={err}
                                   style={alertStyle}>
                                {t("shipment.warnings.copy-or-client-is-ior")}
                            </Alert>
                        );
                }
                return null;
            })}
        </div>
    );
};

export default CopyOr;
